import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["portalId", "authenticatorId", "mcpServerId", "appName", "oAuthScope", "appId", "mcp", "customParams", "onComplete", "onCancel", "introScreen", "successScreen"];
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { MCPAuthModal } from './MCPAuthModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
export const MCPAuthButton = _ref => {
  let {
      portalId,
      authenticatorId,
      mcpServerId,
      appName,
      oAuthScope,
      appId,
      mcp,
      customParams,
      onComplete,
      onCancel = noop,
      introScreen,
      successScreen
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showAuthModal, setShowAuthModal] = useState(false);
  function closeModal() {
    setShowAuthModal(false);
  }
  function onCompleteHandler(secretId) {
    try {
      onComplete(secretId);
    } finally {
      if (!successScreen) {
        closeModal();
      }
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, Object.assign({}, props, {
      onClick: clickEvent => {
        setShowAuthModal(true);
        if (props.onClick) {
          props.onClick(clickEvent);
        }
      }
    })), showAuthModal && /*#__PURE__*/_jsx(MCPAuthModal, {
      authenticatorId: authenticatorId,
      portalId: portalId,
      mcpServerId: mcpServerId,
      appName: appName,
      closeModal: closeModal,
      onCancel: onCancel,
      onComplete: onCompleteHandler,
      introScreen: introScreen,
      successScreen: successScreen,
      oAuthScope: oAuthScope,
      appId: appId,
      mcp: mcp,
      customParams: customParams
    })]
  });
};